import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviDemandeInterventionState } from './state';

export const getters: GetterTree<SuiviDemandeInterventionState, RootState> = {
    getDemandesInterventionsItems(state) {
        return state.demandesIntervention;
    },
    getDemandeInterventionFilterSite(state): number[] {
        return state.filterSite;
    },
    getDemandeInterventionFilterStatus(state): string[] {
        return state.filterStatus;
    },
    getDemandeInterventionFilterDemandeInterventionId(state): string {
        return state.filterDemandeInterventionId;
    },
    getDemandeInterventionFilterMine(state): boolean {
        return state.filterMine;
    },
    getDemandeInterventionFilterCreatedDateFrom(state): string {
        return state.filterCreatedDateFrom;
    },
    getDemandeInterventionFilterCreatedDateTo(state): string {
        return state.filterCreatedDateTo;
    },
    getDemandesInterventionsIsLoading(state) {
        return state.isLoading;
    },
    getDemandesInterventionsPage(state) {
        return state.page;
    },
    getDemandesInterventionsNbOfPages(state) {
        return state.nbOfPages;
    },
    getDemandesInterventionsScroll(state) {
        return state.scroll;
    },
    getDemandesInterventionsSort(state) {
        return state.sort;
    },
    getDemandesInterventionsCount(state) {
        return state.count;
    },
    getDemandesInterventionsTableHeader(state) {
        return state.tableHeader;
    },
    getDemandesInterventionsAttachment(state) {
        return state.attachment;
    },
    getDemandesInterventionsAttachmentType(state) {
        return state.attachmentType;
    },
    getDemandesInterventionsIsAttachmentLoading(state) {
        return state.isAttachmentLoading;
    },
    getDemandesInterventionsExportXlsIsLoading(state) {
        return state.isExportXlsLoading;
    },
};
